import React, { useState, useEffect } from "react";
import * as _ from "lodash";
import { getInfoFound } from "../Invs/ShareFunctionsPrint";
import RevJardPrint from "./Jard/RevGrdPrint";
import LoadingPage from "../../services/LoadingPage";
import { Rept } from "../../Context/InshData";
import RevTransPrintCon from "./transefer/RevTransPrintCon";
import RevAccountsCon from "../Accounts/Balance/RevAccountsCon";
import AccountsConfirmCon from "../Accounts/AccountConfirmation/AccountsConfirmCon";
import RevMultiSandCon from "../Accounts/MultiSQ/RevMultiSandCon";
import RevMezanPrintCon from "../Accounts/mezanPrint/RevMezanPrintCon";
import RestrictionsPrintCon from "../Accounts/restPrint/RestrictionsPrintCon";
import SanadsPrintCon from "../Accounts/voucharPrint/SanadsPrintCon";
import TafsailReportPrintCon from "../Sales/Tafsele/TafsailReportPrintCon";
import InvSearchPrintCon from "../Sales/InvsSearch/InvSearchPrintCon";
import VatReportPrintCon from "../Sales/TaxSalePrint/VatReportPrintCon";
import ShiftsPrintCon from "../Sales/Shiftt/ShiftsPrintCon";
import ActivityReportPrintCon from "../Sales/Activity/ActivityReportPrintCon";
import EmpReportPrintCon from "../Sales/sales-man/EmpReportPrintCon";
import AnalysisReportPrintCon from "../Sales/sale-analysis/AnalysisReportPrintCon";
import SalesmansPrintCon from "../Sales/Salesmanp/SalesmansPrintCon";

function RevPrintDocCon(props) {
    const { typePrint, openConfirm ,dataPrint,info,setInfo} = props;
    const [loading, setLoading] = useState(true);
    const [sta, setSta] = useState({});
    const loodSta=typePrint==11?true:false;
    const number=Number(typePrint);
    const data = openConfirm?{...dataPrint,
        from: "الحساب",
        title: "طلب مصادقة حـساب",}:  
        [1,2,3,4,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].includes(number)?dataPrint: Rept?.data.map((row, i) => {
        return {
            ...row,
            no: i + 1,
        };
    });
    useEffect(() => {
        setTimeout(async () => {
            await getInfoFound(setInfo,loodSta,setSta);
            setLoading(false);
        }, 0);
    }, []);
    if (!info || loading) return <LoadingPage />; 
    return (
        <div>
            {openConfirm || typePrint==6 ? <AccountsConfirmCon info={info} dataConfirm={data} /> :
                (typePrint == 3 ? <RevTransPrintCon info={info} data={data} typePrint={typePrint} /> :
                    typePrint == 4 ? <RevAccountsCon info={info} dataAccounts={data} typePrint={typePrint} /> :
                    typePrint == 7 ? <RevMultiSandCon info={info} dataAccounts={data} typePrint={typePrint} /> :
                    typePrint == 8 ? <RevMezanPrintCon info={info} dataAccounts={data} /> :
                    typePrint == 9 ? <RestrictionsPrintCon info={info} dataAccounts={data} /> :
                    typePrint == 10 || typePrint==11? <SanadsPrintCon info={info} dataAccounts={data}  sta={sta}/> :
                    typePrint == 12 ? <TafsailReportPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 13 ? <InvSearchPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 14 ? <VatReportPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 15|| typePrint==16 ? <ShiftsPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 17 ? <ActivityReportPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 18 ? <EmpReportPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 19 ? <AnalysisReportPrintCon info={info} dataAccounts={data}  /> :
                    typePrint == 20 ? <SalesmansPrintCon info={info} dataAccounts={data}  /> :
                     <RevJardPrint info={info} data={data} typePrint={typePrint} />)}
        </div>
    );
}
export default RevPrintDocCon;
